import { partRunPlaceId } from "../../rail/PartRunPhase/segments";
import type { BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import {
  memberCenterDx,
  siteGroupsMidpointDx,
} from "../../location/LocationRun/siteAnchor";
import type { LocationRun } from "../../location/LocationRun";
import { branchIdForPartRun } from "../../rail/PartRunPhase/phase";

export function activePartCountOnBranch(
  layout: BookTimelineLayout,
  branchId: string,
  playheadMs: number,
): number {
  const branch = layout.rail.branches.find((item) => item.id === branchId);
  if (branch === undefined) {
    return 0;
  }
  const placeIds = new Set<string>();
  for (const stay of layout.rail.stays) {
    if (stay.rootPlaceId !== branch.rootPlaceId) {
      continue;
    }
    if (playheadMs < stay.startMs || playheadMs >= stay.endMs) {
      continue;
    }
    const label = stay.placeLabel;
    if (label === undefined || label === branch.label) {
      continue;
    }
    placeIds.add(stay.placeId ?? stay.rootPlaceId);
  }
  return placeIds.size;
}

function partMemberCenterDx(
  layout: BookTimelineLayout,
  run: LocationRun,
  playheadMs: number,
): number | null {
  const branchId = branchIdForPartRun(run);
  if (branchId === null) {
    return null;
  }
  const branch = layout.rail.branches.find((item) => item.id === branchId);
  if (branch === undefined) {
    return null;
  }
  const placeId = partRunPlaceId(run.runId);
  const characterIds: string[] = [];
  for (const stay of layout.rail.stays) {
    if (stay.rootPlaceId !== branch.rootPlaceId) {
      continue;
    }
    if (playheadMs < stay.startMs || playheadMs >= stay.endMs) {
      continue;
    }
    const stayPlace = stay.placeId ?? stay.rootPlaceId;
    if (stayPlace !== placeId) {
      continue;
    }
    characterIds.push(stay.characterId);
  }
  if (characterIds.length === 0) {
    return null;
  }
  return memberCenterDx(layout.rail, characterIds, playheadMs);
}

export function partCastDx(
  layout: BookTimelineLayout,
  run: LocationRun,
  branchRun: LocationRun,
  playheadMs: number,
): number {
  const onPart = partMemberCenterDx(layout, run, playheadMs);
  if (onPart !== null) {
    return onPart;
  }
  const branchId = branchIdForPartRun(run);
  const partCount = branchId === null
    ? 0
    : activePartCountOnBranch(layout, branchId, playheadMs);
  if (partCount > 1) {
    return 0;
  }
  return siteGroupsMidpointDx(branchRun, layout.rail, playheadMs);
}
